
import { ResumeExperiencePosition } from '@/models/Resume'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: "experience-position-timeline",
    props: {
        position: {
            type: Object as PropType<ResumeExperiencePosition>,
            required: true
        } 
    }
})
